
  <div class="pdf-viewer">
    <pdf-viewer [src]="pdfData"
                  [render-text]="true"
                  [original-size]="false"
                  [autoresize]="true"
                  style="width: 100%; height: 500px"
      ></pdf-viewer>
  </div>
